import React from "react";
import { Divider } from "antd";
import "./function-categories.scss";
import { ReactComponent as SearchIcon } from "../../../../assets/svg/searchIconWithBg.svg";

export const FunctionCategories: React.FC<any> = ({
  onClick,
  allCatagories,
  activeTab,
}) => {
  return (
    <>
      <div className="tabs">
        {allCatagories.map((category: any, index: any) => (
          <button
            data-test-id={`categories_${category}`}
            key={index}
            className={`tab ${category === activeTab ? "active" : ""}`}
            onClick={() => onClick(category)}
          >
            {category}
          </button>
        ))}
        <div className="right">
          <SearchIcon data-test-id="search_icon" width="25px" height="25px" />
        </div>
      </div>
      <Divider style={{ margin: "10px 0" }} />
    </>
  );
};
